import { useQuery } from "@tanstack/react-query"
import { Plane } from "lucide-react"

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@atlant/ui"

import { queryKeys } from "#lib/query-keys.ts"
import { FleetListDocument } from "#pages/authenticated/fleet/page.tsx"
import { useLoggedInUserInfo } from "#store/user-info.ts"
import { client } from "#utils/graphql-client.ts"

interface FlightsAircraftSelectProps {
  value: string
  onChange: (value: string) => void
}

export const FlightsAircraftSelect = ({
  value,
  onChange,
}: FlightsAircraftSelectProps) => {
  const { me } = useLoggedInUserInfo()

  const { data } = useQuery({
    queryKey: queryKeys.aircraft.list(me.organization.id),
    queryFn: () =>
      client.request(FleetListDocument, {
        input: {
          // TODO get from aircraft
          sources: ["LEON", "MANUAL"],
          organizationId: me.organization.id,
        },
      }),
  })

  const aircrafts = data?.aircraftByOrganization ?? []

  return (
    <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
      <SelectTrigger className="gap-1.5 border-none text-sm font-medium shadow-none">
        <Plane className="text-nav-foreground size-4" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="start">
        <SelectItem value="all">All aircraft</SelectItem>
        {aircrafts.map((ac) => (
          <SelectItem key={ac.id} value={ac.id}>
            {ac.tail}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
